import styles from './RecipientModal.module.scss'
import './RecipientModal.scss'

import { Checkbox } from '@material-ui/core'
import {
    FastQuoteInput,
    InternationalPhoneInput,
    StyledRadio,
    AWCButton,
    BUTTON_TYPES,
} from '../../GlobalComponents/Inputs/Inputs'
import { SearchIcon, FilterIcon } from '../../GlobalComponents/_icons/Icons'

import { useAppSelector, useAppDispatch } from '../../app/hooks'
import {
    // useEffect,
    useState,
} from 'react'
import {
    LOADING_STATES,
    selectFilteredContacts,
    AddContactPayload,
    validAddContactPayload,
    postAddContact,
    PACustomerContactViewRow,
} from '../../features/customer/customerSlice'
import { Scrollbars } from 'react-custom-scrollbars-2'
import EmailSearch from './EmailSearch'
import React from 'react'
import { fqAlert } from '../../GlobalComponents/NotificationManager/NotificationManager'
import { formatPhoneNumber } from '../../utils'
import { isFulfilled } from '@reduxjs/toolkit'
import { TextOverflow } from '../../GlobalComponents/_misc/TextOverflow'
import { cleanEmail, validEmail, validPhone } from '../../GlobalComponents/Validator'

interface CheckboxListProps {
    data: any[]
    className: string
    checked: Record<string, boolean | string>
    onChecked(row: any): void
    onUnchecked(row: any): void
    useButtons: boolean
    includeName: boolean
}
// TODO make more generic
const CheckboxList = (props: CheckboxListProps) => {
    const { data, className, checked, onChecked, onUnchecked, useButtons, includeName } = props
    return (
        <div className={className}>
            <Scrollbars
                className={'scroll-bar'}
                renderTrackHorizontal={() => <div />}
                autoHeight
                autoHeightMin={190}
                autoHeightMax={190}
            >
                {data.map((row, i) => (
                    <div
                        style={{
                            height: '2em',
                            display: 'grid',
                            gridTemplateColumns: '1fr 200px',
                            paddingRight: 20,
                            paddingLeft: 10,
                            alignItems: 'center',
                        }}
                        data-testid="recipientModalContactRow"
                        className={styles.checkboxListItem}
                        onClick={() => {
                            if (!!checked[row.EmailAddress]) {
                                onUnchecked(row)
                            } else {
                                onChecked(row)
                            }
                        }}
                        key={`${row.EmailAddress}${i}`}
                    >
                        <div>
                            {useButtons ? (
                                <StyledRadio
                                    checked={!!checked[row.EmailAddress]}
                                    testid={`${row.EmailAddress}RecipientRadio`}
                                    onChange={(checked: boolean) => {
                                        checked ? onChecked(row) : onUnchecked(row)
                                    }}
                                />
                            ) : (
                                <Checkbox
                                    data-testid={`${row.EmailAddress}RecipientCheckbox`}
                                    color={'primary'}
                                    checked={!!checked[row.EmailAddress]}
                                    onChange={(e) => {
                                        e.target.checked ? onChecked(row) : onUnchecked(row)
                                    }}
                                />
                            )}
                            <div
                                className={'centered'}
                                style={{
                                    display: 'inline-flex',
                                    verticalAlign: 'middle',
                                    marginLeft: 8,
                                }}
                            >
                                <TextOverflow
                                    text={row.EmailAddress}
                                    maxWidth={330}
                                    bubbleMinWidth={200}
                                />
                            </div>
                        </div>
                        {includeName && (
                            <div
                                style={{
                                    display: 'inline',
                                    fontStyle: 'italic',
                                    verticalAlign: 'middle',
                                }}
                            >
                                <TextOverflow
                                    text={`${row.FirstName.trim()} ${row.LastName.trim()}`}
                                    maxWidth={200}
                                    bubbleMinWidth={200}
                                    growLeft={true}
                                />
                            </div>
                        )}
                    </div>
                ))}
            </Scrollbars>
        </div>
    )
}

export type AddContactFields = Omit<AddContactPayload, 'accountCode'>

interface AddContactModalProps {
    onCancelClick(): void
    // returns false if failed, true if success
    onSuccess(contact: ContactCustomerAccountCodeViewRow): void
    customer: PACustomerContactViewRow
}

const AddContactModal = (props: AddContactModalProps) => {
    const { onCancelClick, customer, onSuccess } = props
    const dispatch = useAppDispatch()
    const [fields, setFields] = useState<AddContactFields>({
        firstName: '',
        lastName: '',
        title: '',
        email: '',
        phone: '',
    })
    // const [failedToAdd, setFailedToAdd] = useState(false)

    const fieldsValid = (fields: AddContactFields) => {
        return (
            fields.firstName.trim() &&
            fields.lastName.trim() &&
            validEmail(fields.email) &&
            (!fields.phone || validPhone(fields.phone))
        )
    }
    const onSubmit = async (
        fields: AddContactFields
    ): Promise<ContactCustomerAccountCodeViewRow | false> => {
        let e = ''
        if (!validEmail(fields.email)) {
            e += 'You must enter a valid email\n'
        }
        if (fields.phone && !validPhone(fields.phone)) {
            e += 'You must enter a valid phone number'
        }
        if (e.length > 0) {
            fqAlert({ type: 'warning', message: e })

            return false
        }

        let payload = {
            ...fields,
            email: cleanEmail(fields.email),
            // phone: cleanPhone(fields.phone),
            phone: formatPhoneNumber(fields.phone, phoneExtension),
            accountCode: customer.AccountCode,
        }
        if (validAddContactPayload(payload)) {
            let existingContact = unfilteredContacts.find(
                (row) => row.EmailAddress!.toLowerCase() === fields.email.toLowerCase()
            )
            if (existingContact) return existingContact
            let res = await dispatch(postAddContact(payload))
            if (isFulfilled(res)) {
                let newContact: ContactCustomerAccountCodeViewRow = {
                    FirstName: fields.firstName,
                    LastName: fields.lastName,
                    EmailAddress: fields.email,
                    ContactCompanyName: customer.ShipToName!,
                    ContactKey: -1,
                    CustomerAccountCode: customer.AccountCode,
                    Prospect: true,
                }
                return newContact
            } else {
                return false
            }
        } else {
            return false
        }
    }
    const [emailValidationText, setEmailValidationText] = useState('')
    function handlePhoneNumberBlur(e: any) {
        setPhoneFieldActive(false)
    }
    const [phoneFieldActive, setPhoneFieldActive] = React.useState<boolean>(false)
    const [phoneExtension, SetPhoneExtension] = useState('')

    const handleFocus = (event: any) => {
        event.target.select()
    }

    const unfilteredContacts = useAppSelector(
        (state) => state.customer.customerContacts[state.customer.currentCustomer!.AccountCode]
    )
    return (
        <div className={'recipientModal'} data-testid={'recipientModal'}>
            <div>
                <div className={styles.inputGrid}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                        <FastQuoteInput
                            onChange={(value: string) =>
                                setFields((fields) => ({ ...fields, firstName: value }))
                            }
                            value={fields.firstName}
                            title={'First Name'}
                            autoFocus
                            maxLength={24}
                            required
                            testid="recipientModalCreateNewContactFirstName"
                        />
                        <FastQuoteInput
                            onChange={(value: string) =>
                                setFields((fields) => ({ ...fields, lastName: value }))
                            }
                            value={fields.lastName}
                            title={'Last Name'}
                            maxLength={24}
                            required
                            testid="recipientModalCreateNewContactLastName"
                        />
                    </div>
                    <div
                        style={{
                            display: 'grid',
                            gap: 10,
                            gridTemplateColumns: '1fr 180px',
                        }}
                    >
                        <InternationalPhoneInput
                            onChange={(value: string) => {
                                setPhoneFieldActive(true)
                                const re = /^[0-9\b]+$/

                                if (value === '' || re.test(value)) {
                                    setFields((fields) => ({ ...fields, phone: value }))
                                }
                            }}
                            value={fields.phone}
                            onFocus={handleFocus}
                            placeholder={'(___)___-____'}
                            title={'Phone Number'}
                            onBlur={handlePhoneNumberBlur}
                            validationText={`${
                                !phoneFieldActive && fields.phone && !validPhone(fields.phone)
                                    ? ' Invalid Phone'
                                    : ''
                            }`}
                            testid="recipientModalCreateNewContactPhone"
                        />
                        {/* {!hasPhoneExtension ? (
                            <span
                                className={styles.phoneExtensionButton}
                                onClick={() => setHasPhoneExtension(true)}
                            >
                                <span className={styles.plusButton} />
                                <div>Add Phone Extension</div>
                            </span>
                        ) : ( */}
                        <FastQuoteInput
                            title={'Ext.'}
                            value={phoneExtension}
                            onChange={(value: string) => {
                                const re = /^[0-9\b]+$/

                                if (value === '' || re.test(value)) {
                                    SetPhoneExtension(value)
                                }
                            }}
                            maxLength={4}
                        />
                        {/* )} */}
                    </div>
                    {/* <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                    <FastQuoteInput
                            onChange={(value: string) => {
                                setFields((fields) => ({ ...fields, phone: value }))
                                setPhoneFieldActive(true)
                            }}
                            value={fields.phone}
                            placeholder={'(___)___-____'}
                            title={'Phone'}
                            maxLength={20}
                            validationText={`${
                                !phoneFieldActive && fields.phone && !validPhone(fields.phone)
                                    ? ' Invalid Phone'
                                    : ''
                            }`}
                        /> */}
                    <FastQuoteInput
                        onChange={(value: string) =>
                            setFields((fields) => ({ ...fields, title: value }))
                        }
                        value={fields.title}
                        title={'Title'}
                        maxLength={35}
                        testid="recipientModalCreateNewContactTitle"
                    />
                    {/* </div> */}
                    <FastQuoteInput
                        onChange={(value: string) => {
                            setFields((fields) => ({ ...fields, email: value }))
                            // clear out while they're inputting
                            setEmailValidationText('')
                        }}
                        value={fields.email}
                        title={'Email Address'}
                        placeholder={'example@ab.com'}
                        maxLength={60}
                        validationText={emailValidationText}
                        onBlur={() =>
                            setEmailValidationText(
                                fields.email && !validEmail(fields.email) ? ' Invalid Email' : ''
                            )
                        }
                        required
                        testid="recipientModalCreateNewContactEmailAddress"
                    />
                </div>

                <div className={styles.buttonContainer}>
                    <AWCButton
                        type="secondary"
                        onClick={onCancelClick}
                        data-testid="recipientModalCreateNewContactCancel"
                    >
                        Cancel
                    </AWCButton>
                    <AWCButton
                        type={fieldsValid(fields) ? 'primary' : 'disabled'}
                        onClick={async () => {
                            let contact = await onSubmit(fields)
                            if (contact) onSuccess(contact)
                            //else setFailedToAdd(true)
                        }}
                        data-testid="recipientModalCreateNewContactSubmit"
                        style={{ width: 135 }}
                    >
                        Add Contact
                    </AWCButton>
                </div>
            </div>
        </div>
    )
}
interface RecipientModalBaseProps {
    close(): void
    required: boolean
    reason?: 'To' | 'Cc'
    // if it's given there will be a cancel button
    onCancel: () => void
}

interface RecipientModalSingleProps extends RecipientModalBaseProps {
    submitContact(contact: ContactCustomerAccountCodeViewRow): void
    singleChoice: true
    selectedContact?: ContactCustomerAccountCodeViewRow
}
interface RecipientModalMultiProps extends RecipientModalBaseProps {
    submitContacts(contacts: Array<ContactCustomerAccountCodeViewRow | string>): void
    singleChoice: false
    selectedContacts?: Array<ContactCustomerAccountCodeViewRow | string>
}
type RecipientModalProps = RecipientModalMultiProps | RecipientModalSingleProps
const RecipientModal = (props: RecipientModalProps) => {
    const { close, singleChoice, required, reason, onCancel } = props
    const customer = useAppSelector((state) => state.customer.currentCustomer!)

    const [filter, setFilter] = useState('')
    const filteredContacts = useAppSelector((state) =>
        selectFilteredContacts(state, state.customer.currentCustomer!.AccountCode, filter)
    )
    const contacts = useAppSelector(
        (state) =>
            state.customer.customerContacts[state.customer.currentCustomer!.AccountCode] || []
    )
    const contactsLoading = useAppSelector((state) => state.customer.contactsLoading)
    let ccContacts = useAppSelector((state) => state.order.ccContacts)
    let toContact = useAppSelector((state) => state.order.toContact)

    const [selectedContacts, setSelectedContacts] = useState<Record<string, boolean | string>>(
        () => {
            let initObj: Record<string, boolean | string> = {}
            // if they pass in a value default to it otherwise use order to/cc for defaults
            if (!props.singleChoice && props.selectedContacts) {
                props.selectedContacts.forEach((row) => {
                    initObj[typeof row === 'string' ? row : row.EmailAddress!] = true
                })
                return initObj
            }
            if (props.singleChoice && props.selectedContact) {
                initObj[props.selectedContact.EmailAddress!] = true
                return initObj
            }
            if (props.reason === 'To') {
                if (toContact) initObj[toContact.EmailAddress!] = true
            } else {
                ccContacts.forEach((row) => {
                    initObj[typeof row === 'string' ? row : row.EmailAddress!] = true
                })
            }
            return initObj
        }
    )
    const [creatingNewContact, setCreatingNewContact] = useState(false)

    let onConfirmClick = () => {
        let contactEmails = Object.keys(selectedContacts)
        let allContacts = contactEmails.map(
            (row) => contacts.find((contact) => row === contact.EmailAddress) || row
        )
        if (props.singleChoice) {
            props.submitContact(allContacts[0] as ContactCustomerAccountCodeViewRow)
        } else {
            props.submitContacts(allContacts)
        }
        close()
    }
    const onCancelClick = () => {
        setCreatingNewContact(false)
    }

    const onAddContactSuccess = (contact: ContactCustomerAccountCodeViewRow) => {
        if (props.singleChoice) props.submitContact(contact)
        else {
            setSelectedContacts((selected) => ({
                ...selected,
                [cleanEmail(contact.EmailAddress!)]: true,
            }))
            setCreatingNewContact(false)
        }
    }

    let currentTo
    if (Object.keys(selectedContacts).length === 1)
        currentTo = contacts.find(
            (row) =>
                typeof row !== 'string' && row.EmailAddress === Object.keys(selectedContacts)[0]
        )
    let selectedContactsArray = Object.keys(selectedContacts).map((row) => {
        let contact = contacts.find((contact) => contact.EmailAddress === row)
        return contact || row
    })
    enum SORT_ORDERS {
        NAME,
        EMAIL,
    }
    const [currentSort, setCurrentSort] = useState<SORT_ORDERS>(SORT_ORDERS.NAME)
    const sortByEmail = () => {
        setCurrentSort(SORT_ORDERS.EMAIL)
    }
    const sortByName = () => {
        setCurrentSort(SORT_ORDERS.NAME)
    }
    const cleanName = (contact: ContactCustomerAccountCodeViewRow) => {
        return `${contact.FirstName.toUpperCase().trim()} ${contact.LastName.toUpperCase().trim()}`
    }
    const sortedContacts = filteredContacts.sort((a, b) => {
        if (currentSort === SORT_ORDERS.NAME) {
            return cleanName(a) < cleanName(b) ? -1 : 1
        } else {
            return a.EmailAddress!.toUpperCase() < b.EmailAddress!.toUpperCase() ? -1 : 1
        }
    })

    if (creatingNewContact) {
        return (
            <AddContactModal
                onCancelClick={onCancelClick}
                customer={customer}
                onSuccess={onAddContactSuccess}
            />
        )
    }

    if (contactsLoading !== LOADING_STATES.DONE) return <div></div>
    return (
        <div className={'recipientModal'} data-testid={'recipientModal'}>
            <div className={styles.recipientModalHeader}>
                <div className={styles.recipientModalTitle}>{`${
                    customer.CustomerName || customer.BillToName
                } (${customer.AccountCode.trim()})`}</div>
                {!required && <div onClick={close} className={'a-i-close'} />}
            </div>

            <div className={'a-divider'} style={{ marginBottom: 10 }} />
            {singleChoice ? (
                <div style={{ marginBottom: 5 }}>Select or create a new contact</div>
            ) : (
                <div>Add Additional Recipients</div>
            )}

            {singleChoice ? (
                <div style={{ display: 'flex', marginBottom: 20 }}>
                    <span style={{ marginRight: 5, alignSelf: 'center', fontWeight: 500 }}>
                        To:
                    </span>
                    <EmailSearch
                        contacts={filteredContacts}
                        onCreateNewContact={() => setCreatingNewContact(true)}
                        selectedContact={currentTo}
                        setSelectedContact={(newContact) => {
                            setSelectedContacts({ [newContact.EmailAddress!]: true })
                        }}
                        onInvalid={() => {
                            setSelectedContacts({})
                        }}
                        onClear={() => {
                            setSelectedContacts({})
                        }}
                        allowFreeform={false}
                    />
                </div>
            ) : (
                <div style={{ display: 'flex', marginBottom: 20 }}>
                    <span style={{ marginRight: 5, alignSelf: 'center', fontWeight: 500 }}>
                        {reason ? (reason === 'To' ? 'To:' : 'Cc:') : 'Cc:'}
                    </span>
                    <EmailSearch
                        contacts={filteredContacts}
                        onCreateNewContact={() => setCreatingNewContact(true)}
                        selectedContacts={selectedContactsArray}
                        multiple
                        setSelectedContacts={(newContacts) => {
                            let newSelectedContacts: typeof selectedContacts = {}
                            newContacts.forEach((row) => {
                                if (typeof row === 'string') {
                                    newSelectedContacts[row] = true
                                } else {
                                    newSelectedContacts[row.EmailAddress!] = true
                                }
                            })
                            setSelectedContacts(newSelectedContacts)
                        }}
                    />
                </div>
            )}
            <FastQuoteInput
                title={''}
                validationText={''}
                Icon={singleChoice ? FilterIcon : SearchIcon}
                onChange={setFilter}
                testid={'filterEmailOrName'}
                value={filter}
                placeholder={'Filter by email or name'}
                autoFocus
                infoText={''}
                renderEndIcon={() =>
                    filter && (
                        <div
                            style={{ width: 18, height: 15 }}
                            className={'a-i-close'}
                            data-testid="filterEmailOrNameClose"
                            // intentionally mousedown because mousedown triggers parent blur
                            onMouseDown={() => {
                                setFilter('')
                            }}
                        />
                    )
                }
            />

            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 200px',
                    paddingRight: 20,
                    paddingLeft: 10,
                    fontWeight: 500,
                    marginTop: 15,
                }}
            >
                <div style={{ marginLeft: 25, cursor: 'pointer' }} onClick={sortByEmail}>
                    Email
                </div>
                <div style={{ cursor: 'pointer' }} onClick={sortByName}>
                    Name
                </div>
            </div>
            <div className={'a-divider'} style={{ marginTop: 5, marginBottom: 10 }} />
            <CheckboxList
                data={sortedContacts}
                checked={selectedContacts}
                onChecked={(row: ContactCustomerAccountCodeViewRow) => {
                    if (singleChoice) {
                        setSelectedContacts({
                            [row.EmailAddress!]: true,
                        })
                    } else {
                        setSelectedContacts((selected) => ({
                            ...selected,
                            [row.EmailAddress!]: true,
                        }))
                    }
                }}
                onUnchecked={(row: ContactCustomerAccountCodeViewRow) =>
                    !singleChoice &&
                    setSelectedContacts((selected) => {
                        delete selected[row.EmailAddress!]
                        return { ...selected }
                    })
                }
                className={styles.emailCheckboxList}
                useButtons={!!singleChoice}
                includeName={true}
            />
            <div className={'a-divider'} style={{ marginTop: 30, marginBottom: 20 }} />
            {!creatingNewContact && (
                <div style={{ height: 21 }}>
                    <span
                        className={styles.newContactButton}
                        onClick={() => setCreatingNewContact(true)}
                    >
                        <span className={styles.plusButton} />
                        <span data-testid="recipientModalCreateNewContact">Create New Contact</span>
                    </span>
                </div>
            )}
            <div
                style={{
                    justifyContent: 'flex-end',
                    display: 'grid',
                    gridTemplateColumns: '110px 110px',
                    marginTop: 10,
                }}
            >
                <AWCButton
                    type={'secondary'}
                    style={{
                        width: 94,
                    }}
                    onClick={onCancel}
                    data-testid="recipientModalCancelButton"
                >
                    Cancel
                </AWCButton>
                <AWCButton
                    type={
                        (singleChoice && Object.keys(selectedContacts).length !== 1) ||
                        (required && Object.keys(selectedContacts).length === 0)
                            ? 'disabled'
                            : BUTTON_TYPES.PRIMARY
                    }
                    onClick={onConfirmClick}
                    data-testid="recipientModalSubmitButton"
                >
                    Save
                </AWCButton>
            </div>
        </div>
    )
}

export default RecipientModal
export { AddContactModal }
